import React, { useState, useEffect } from "react";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { Get_Null_Country_Schools } from "../api/Get_Null_Country_Schools";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";

function AssignSchoolToCountry() {
  const { logout } = StaffuseAuth();

  // Assuming Attendee state is fetched from an API using the id
  const [School, setSchool] = useState({});

  useEffect(() => {
    Get_Null_Country_Schools(setSchool, 1, "GetOne", logout);
  }, []);

  //This is the state for the update progress
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleBasicUpdate = (e) => {
    e.preventDefault();
    let id = School._id;
    let data = School;
    delete data._id;
    data.School_Country = Country;
    Update_To_MongoDB_By_ID(
      data,
      "Schools",
      "All_Schools",
      setIsSubmitting,
      id,
      logout
    );
    console.log(Country);
  };

  const handleGetNew = (e) => {
    e.preventDefault();
    Get_Null_Country_Schools(setSchool, 1, "GetOne", logout);
  };

  const [Country, setCountry] = useState("");
  function handleTypeCountry(event) {
    setCountry(event.target.value);
  }

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        <div style={{ width: "45%" }}>
          <h1>Assign a Country to a School</h1>
          <p>
            If any Schools do not have a country, you can help out here !
            <br></br>
            <br></br>
            Use the basic information on the right, use google, enter the
            country, click "Update" and then click "Get Next School" to go to
            the next example.<br></br>
          </p>
        </div>
        {School.School_Name && School.School_Name !== "" ? (
          <div style={{ width: "45%" }}>
            <h1>Info:</h1>
            <h2> Name: {School.School_Name}</h2>
            <h2> Country: {School.School_Country}</h2>
            <h2> PostCode: {School.School_PostCode}</h2>
            <h2> Region: {School.School_Region}</h2>
            <h2> Type: {School.School_Type}</h2>
            <br></br>
            <h2> School _id: {School._id}</h2>
            <h1>Actions:</h1>
            <input
              id="Country"
              label="Country"
              value={Country}
              onChange={handleTypeCountry}
            ></input>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, ml: 1 }}
              disabled={isSubmitting || Country === ""}
              style={{ backgroundColor: "green" }}
              onClick={(e) => handleBasicUpdate(e)}
            >
              {isSubmitting ? "Submitting..." : "Update School"}
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, ml: 1 }}
              onClick={(e) => handleGetNew(e)}
            >
              {isSubmitting ? "Submitting..." : "Get Next School"}
            </Button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default AssignSchoolToCountry;
